var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "pa-2": "" } },
    [
      _c(
        "v-container",
        { attrs: { "grid-list-md": "", "pa-0": "", "pb-4": "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs11: "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs4: "" } },
                        [
                          _c("mr-autocomplete-selector", {
                            attrs: {
                              items: _vm.Categories,
                              onChange: _vm.handleFilterChange,
                              label: "Catégorie",
                              itemText: "name",
                              itemValue: "id",
                              loading: false,
                              disabled: false,
                              multiple: false,
                              clearable: ""
                            },
                            model: {
                              value: _vm.searchParams.char1,
                              callback: function($$v) {
                                _vm.$set(_vm.searchParams, "char1", $$v)
                              },
                              expression: "searchParams.char1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "" } },
                        [
                          _c("mr-autocomplete-selector", {
                            attrs: {
                              items: _vm.SubCategories,
                              onChange: _vm.handleFilterChange,
                              label: "Sous-catégorie",
                              itemText: "name",
                              itemValue: "id",
                              loading: false,
                              disabled: !_vm.searchParams.char1,
                              multiple: false,
                              clearable: ""
                            },
                            model: {
                              value: _vm.searchParams.char2,
                              callback: function($$v) {
                                _vm.$set(_vm.searchParams, "char2", $$v)
                              },
                              expression: "searchParams.char2"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "" } },
                        [
                          _c("mr-autocomplete-selector", {
                            attrs: {
                              items: _vm.coFilterType,
                              onChange: _vm.handleFilterChange,
                              label: "Type",
                              itemText: "name",
                              itemValue: "value",
                              loading: false,
                              disabled: false,
                              clearable: ""
                            },
                            model: {
                              value: _vm.searchParams.type,
                              callback: function($$v) {
                                _vm.$set(_vm.searchParams, "type", $$v)
                              },
                              expression: "searchParams.type"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs1: "" } },
                [
                  _c(
                    "v-tooltip",
                    { attrs: { top: "" } },
                    [
                      _c(
                        "template",
                        { slot: "activator" },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                outline: "",
                                icon: "",
                                color: "secondary"
                              },
                              on: { click: _vm.resetFilter }
                            },
                            [_c("v-icon", [_vm._v("delete_forever")])],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("Réinitialiser le filtre de recherche")
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-2",
        attrs: {
          headers: _vm.headers,
          items: _vm.templates,
          pagination: _vm.pagination,
          "total-items": _vm.totalTemplates,
          loading: _vm.loading,
          "rows-per-page-items": [10, 25, 50],
          "rows-per-page-text": "Lignes par page",
          "no-data-text": "Pas de données disponibles"
        },
        on: {
          "update:pagination": function($event) {
            _vm.pagination = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function(props) {
              return [
                _c("td", { staticStyle: { height: "70px" } }, [
                  _c("span", { staticClass: "primaryDark--text" }, [
                    _c("b", [_vm._v(_vm._s(props.item.name))])
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  !props.expanded
                    ? _c("span", { staticClass: "greyDark--text" }, [
                        _vm._v(_vm._s(_vm.truncate(props.item.description, 80)))
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "greyDark--text" }, [
                  _vm._v(_vm._s(props.item.maintenance_category))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "greyDark--text" }, [
                  _vm._v(_vm._s(props.item.type_formatted))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "greyDark--text" }, [
                  _vm._v(_vm._s(props.item.interval_formatted))
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "justify-center align-center px-0" },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { flat: "", icon: "", small: "" },
                        on: {
                          click: function($event) {
                            _vm.editTemplate(props.item)
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { color: "primaryDark" } }, [
                          _vm._v("edit")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        attrs: { flat: "", icon: "", small: "" },
                        on: {
                          click: function($event) {
                            _vm.idTemplateToDelete = props.item.id
                            _vm.dialogDelete = true
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { color: "primaryDark" } }, [
                          _vm._v("delete")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          staticClass: "delete--dialog",
          attrs: { persistent: "", "max-width": "400" },
          model: {
            value: _vm.dialogDelete,
            callback: function($$v) {
              _vm.dialogDelete = $$v
            },
            expression: "dialogDelete"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { color: "primary", dark: "" } },
            [
              _c(
                "v-card-text",
                { attrs: { "text-xs-left": "" } },
                [
                  _c(
                    "v-layout",
                    {
                      staticClass: "mb-1",
                      attrs: { row: "", "align-center": "" }
                    },
                    [
                      _c("v-icon", { attrs: { "x-large": "", color: "red" } }, [
                        _vm._v("warning")
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "ml-4 mt-3 delete--dialog__text" },
                        [_vm._v("Cette template sera immédiatement supprimée.")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-xs-center" }, [
                    _c("b", [_vm._v("ATTENTION")]),
                    _vm._v(", cette action est irréversible !")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider", { attrs: { color: "white" } }),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "pa-0 delete--dialog__actions" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", color: "white" },
                      on: {
                        click: function($event) {
                          _vm.idTemplateToDelete = null
                          _vm.dialogDelete = false
                        }
                      }
                    },
                    [_vm._v("Annuler")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", color: "white" },
                      on: { click: _vm.deleteTemplate }
                    },
                    [_vm._v("Supprimer")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c6fb468", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c6fb468","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/profile/maintenance-template/template.html
// module id = null
// module chunks = 